import { getField } from 'vuex-map-fields'

export default {
  getField,
  user: (state) => state.user,
  changedUserProperties: (state) => state.changedUserProperties,
  changedPersonalInboxProperties: (state) => state.changedPersonalInboxProperties,
  // Unsaved edits to the user or to the personal line's missed-call settings, the two that Save stores
  hasUnsavedChanges: (state) => state.changedUserProperties.length > 0 || state.changedPersonalInboxProperties.length > 0
}
